










































import { Vue, Component, Prop } from 'vue-property-decorator';
import { TypeItem, TypeList, CommonObject } from 'src/types/views/common';
import { ListTypeName } from 'src/types/components/selection';
import * as api from 'service/api';

@Component
export default class SelectionBlock extends Vue {
  @Prop({ default: false }) readonly hasThird!: boolean;

  @Prop(String) readonly title!: string;

  @Prop(String) readonly funName!: string;

  @Prop(String) readonly parentIdName!: string;

  @Prop({ default: '0' }) readonly initialParentId!: string;

  firstTypeList: TypeItem[] = [];

  secondTypeList: TypeItem[] = [];

  thirdTypeList: TypeItem[] = [];

  firstType = '';

  firstTypeName = '';

  secondType = '';

  secondTypeName = '';

  thirdType = '';

  thirdTypeName = '';

  async getTypeList(id: string, list: ListTypeName) {
    const res = await (api as CommonObject)[this.funName]({
      [this.parentIdName]: id,
    });
    this[list] = (res as TypeList).data.rows.map(item => ({
      name: item.abbreviation || item.name,
      id: String(item.id),
    }));
  }

  selectFirstType(id: string, name: string) {
    this.firstType = id;
    this.firstTypeName = name;
    this.getTypeList(id, ListTypeName.secondTypeList);
    this.$emit('select-one', id, name);
  }

  cancelFirstType() {
    this.firstType = '';
    this.firstTypeName = '';
    this.secondType = '';
    this.secondTypeName = '';
    this.secondTypeList = [];
    this.thirdType = '';
    this.thirdTypeName = '';
    this.thirdTypeList = [];
    this.$emit('select-one', '', '');
  }

  cancelSecondType() {
    this.secondType = '';
    this.secondTypeName = '';
    this.thirdType = '';
    this.thirdTypeName = '';
    this.thirdTypeList = [];
    this.$emit('select-two', '', '');
  }

  cancelThirdType() {
    this.thirdType = '';
    this.thirdTypeName = '';
    this.$emit('select-three', '', '');
  }

  selectSecondType(id: string, name: string) {
    this.secondType = id;
    this.secondTypeName = name;
    this.$emit('select-two', id, name);
    if (this.hasThird) {
      this.getTypeList(id, ListTypeName.thirdTypeList);
    }
  }

  selectThirdType(id: string, name: string) {
    this.thirdType = id;
    this.thirdTypeName = name;
    this.$emit('select-three', id, name);
  }

  mounted() {
    this.getTypeList(this.initialParentId, ListTypeName.firstTypeList);
  }
}
